module.exports = __webpack_public_path__ + "img/symbol_staryellow.6f609775.png";